import PopoverContainer from 'components/common/Popover/PopoverContainer'
import React from 'react'

const Tooltip = ({cssClass="",data}) => {
  return (
    <PopoverContainer
        cssClass={`${cssClass} text-sm bg-gradient`}
        itemComponent={() => {}}
        toolTip={`${data}`}
      >
   
      </PopoverContainer>
  )
}

export default Tooltip
